import React from 'react';
import { isMobile, isTablet, isAndroid } from 'react-device-detect';
import styled from 'styled-components';
import Button from '../../components/Button/Button';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { pwaStyleAdapter } from '../../utils/mobileSupported';
import generateRender from 'shared/utils/generateRender';
import useCheckCloseLTOConfirmation from 'shared/screens/LimitedTimeOffer/hooks/useCheckCloseLTOConfirmation';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';

function AreYouSureLTO() {
  const { dismissModal, goBackToLTO } = useCheckCloseLTOConfirmation();

  const yesButtonSource = generateRender({
    default: assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY),
    ti: assetSource(ASSET_KEY.ROUNDED_RECT_SECONDARY),
  });

  return (
    <BackgroundContainer>
      <StyledBackground
        textStroke={BUTTON_STROKES.GREEN}
        onClick={dismissModal}
        imageSource={yesButtonSource}
        label={getText(TEXT_KEY.YES)}
      />
      <StyledBackground
        textStroke={BUTTON_STROKES.DANGER}
        onClick={goBackToLTO}
        imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_DANGER)}
        label={getText(TEXT_KEY.NO)}
      />
    </BackgroundContainer>
  );
}

export default AreYouSureLTO;

AreYouSureLTO.hideDefaultBackground = true;
AreYouSureLTO.hideCloseButton = true;

const BackgroundContainer = styled.div`
  width: 130%;
  position: relative;
  right: 15%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-image: url(${assetSource(ASSET_KEY.LTO_ARE_YOU_SURE)});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  padding-bottom: 7vh;
  ${({ theme }) =>
    theme.screens.devices(['mobile-browser', 'mobile-standalone', 'tablet-browser', 'tablet-standalone']) &&
    `
    padding-bottom: 8vh;
  `}
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['tablet-browser', 'tablet-standalone']) &&
    `
    padding-bottom: 12vh;
  `}
`;

const StyledBackground = styled(Button).attrs({
  containerStyle: {
    width: isMobile || (isTablet && isAndroid) ? '12vw' : '14vw',
    height: isTablet && !isAndroid ? '9vh' : '8vh',
    cursor: 'pointer',
    margin: isTablet && isAndroid ? '0 1vw' : `0 1.5vw`,
  },
  imageStyle: {
    width: isMobile || (isTablet && isAndroid) ? '12vw' : '14vw',
    height: isTablet && !isAndroid ? '9vh' : '8vh',
    cursor: 'pointer',
  },
  textStyle: {
    fontSize: pwaStyleAdapter(isAndroid && !isTablet ? 1.4 : 1.6, 'rem'),
    fontWeight: 700,
  },
})`
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
`;

